import * as React from 'react';
import { compose, setDisplayName, withHandlers, lifecycle, withState } from 'recompose';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { skin } from 'ui/styles/skin';
import { DeviceMap, DeviceIndex, DeviceIdMap } from 'types';
import { State } from 'reducers';
import { getDevices, isLoadingDevices, getDeviceIdByDeviceIndex } from 'selectors/deviceSelectors';
import { MonitoringCell } from 'ui/pages/monitoring/mainPanel/MonitoringCell';
import { assignStream, setScroll } from 'actions/monitoringActions';
import { makeStreamId } from 'util/streamId';

export type OwnProps = {
    busy: boolean;
    visible: boolean;
    deviceIndex: DeviceIndex;
};

export const RawChangeImageCell = ({ busy }: OwnProps & RecomposeProps) =>
    <MonitoringCell
        cellIndex={ 0 }
        disabled={ busy }
    />
;

type StateProps = {
    devices: DeviceMap | null;
    loading: boolean;
    deviceIdByDeviceIndex: DeviceIdMap;
};
type DispProps = {
    loadStream: (streamId: string) => void;
    scrollToBottom: () => void;
};
type RecomposeProps = {
    busy: boolean;
    handleLoadCamera: () => void;
};
type _RecomposeProps = RecomposeProps & {
    _setBusy: (b: boolean) => void;
};

const mapStateToProps = (state: State) => ({
    devices: getDevices(state),
    loading: isLoadingDevices(state),
    deviceIdByDeviceIndex: getDeviceIdByDeviceIndex(state),
});

const mapDispToProps = (dispatch: Function, ownProps: OwnProps) => ({
    loadStream: (streamId: string) => dispatch(assignStream({ streamId, cellIndex: 0, paused: true })),
    scrollToBottom: () => dispatch(setScroll({ cellIndex: 0, scroll: 1 })),
});

export const ChangeImageCell = compose<OwnProps & StateProps & DispProps & RecomposeProps & TranslateProps, OwnProps>(
    setDisplayName('ChangeImageCell'),
    skin,
    translate(),
    connect<StateProps, DispProps, OwnProps>(mapStateToProps, mapDispToProps),
    withState('busy', '_setBusy', false),
    withHandlers<OwnProps & StateProps & DispProps & _RecomposeProps, Partial<RecomposeProps>>({
        handleLoadCamera: ({ deviceIndex, deviceIdByDeviceIndex, loadStream }) => () => {
            const deviceId = deviceIdByDeviceIndex[`${deviceIndex}`];
            const streamId = makeStreamId(deviceId, 0);
            loadStream(streamId);
        },
    }),
    lifecycle<OwnProps & StateProps & DispProps & RecomposeProps, {}>({
        componentDidMount() {
            this.props.handleLoadCamera();
        },
        componentDidUpdate(oldProps) {
            const { deviceIndex, deviceIdByDeviceIndex, handleLoadCamera, visible, scrollToBottom } = this.props;

            // Load video again if the device changed
            if (deviceIndex !== oldProps.deviceIndex ||
                deviceIdByDeviceIndex !== oldProps.deviceIdByDeviceIndex) {
                handleLoadCamera();
            }
            // Scroll the timeline to the bottom when visibility changes
            if (visible !== oldProps.visible) {
                scrollToBottom();
            }
        },
    }),
)(RawChangeImageCell);



// WEBPACK FOOTER //
// ./src/ui/pages/changeImage/ChangeImageCell.tsx